<template>
  <span class="pageSteps card-styling">
    <span
      v-for="(item, index) in items"
      :key="index"
      class="breadcrumb-item-wrapper"
    >
      <p
        v-if="item.route"
        :style="{
          fontWeight: item.active ? '500' : '300',
          fontStyle: 'normal',
          cursor: 'pointer',
          margin: 0,
          display: 'inline',
        }"
        @click="navigate(item.route)"
        role="button"
      >
        {{ item.label }}
      </p>
      <p
        v-else
        :style="{
          fontWeight: item.active ? '500' : '300',
          fontStyle: 'normal',
          margin: 0,
          display: 'inline',
        }"
      >
        {{ item.label }}
      </p>
      <img
        v-if="index < items.length - 1"
        style="margin: 0 17px"
        :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
        alt=""
      />
    </span>
  </span>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      required: true,
      // Exemplo: [
      //   { label: 'Dashboard', route: { name: 'Dashboard' } },
      //   { label: 'Postagens', route: { name: 'Posts' } },
      //   { label: 'Detalhes', active: true }
      // ]
    },
  },
  methods: {
    navigate(route) {
      if (route) {
        this.$router.push(route);
      }
    },
  },
};
</script>

<style scoped>
.breadcrumb-item-wrapper {
  display: inline-flex;
  align-items: center;
}

.pageSteps p[role="button"]:hover {
  color: var(--blue-medium, #2485ea);
  text-decoration: underline;
}
</style>
